import { Button, ButtonGroup, Checkbox, Stack } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SupplierRelationDto } from "../../../autogen/bff-api";
import { useSupplierRelationLabels } from "./useSupplierRelationLabels";

interface Props {
  relations: SupplierRelationDto[];
  withoutRelations: SupplierRelationDto[];
  onChange: (change: { relations: SupplierRelationDto[]; withoutRelations: SupplierRelationDto[] }) => void;
}

export const RelationFilter = ({ relations, withoutRelations, onChange }: Props) => {
  const { t } = useTranslation();
  const labels = useSupplierRelationLabels();
  const [side, setSide] = useState<"has" | "hasNot">(
    relations.length === 0 && withoutRelations.length > 0 ? "hasNot" : "has",
  );
  const ticked = side === "has" ? relations : withoutRelations;
  const other = side === "has" ? withoutRelations : relations;
  const offered = Object.values(SupplierRelationDto).filter((relation) => !other.includes(relation));
  const toggle = (relation: SupplierRelationDto, checked: boolean) => {
    const next = checked ? [...ticked, relation] : ticked.filter((r) => r !== relation);
    onChange(side === "has" ? { relations: next, withoutRelations } : { relations, withoutRelations: next });
  };

  return (
    <Stack spacing="3">
      <ButtonGroup size="sm" isAttached>
        {(["has", "hasNot"] as const).map((option) => (
          <Button
            key={option}
            aria-pressed={side === option}
            colorScheme={side === option ? "teal" : "gray"}
            variant={side === option ? "solid" : "outline"}
            onClick={() => setSide(option)}
          >
            {option === "has" ? t("Has") : t("Has not")}
          </Button>
        ))}
      </ButtonGroup>
      <Stack spacing="1" role="group" aria-label={(side === "has" ? t("Has") : t("Has not")) as string}>
        {offered.map((relation) => (
          <Checkbox
            key={relation}
            size="sm"
            isChecked={ticked.includes(relation)}
            onChange={(e) => toggle(relation, e.target.checked)}
          >
            {labels[relation]}
          </Checkbox>
        ))}
      </Stack>
    </Stack>
  );
};
